import { combineReducers } from "redux";
import jobReducer from "./job";
import filterReducer from "./filter";
import directionReducer from "./direction";
import mapReducer from "./map";

const reducers = combineReducers({
  jobReducer,
  filterReducer,
  directionReducer,
  mapReducer,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js